import type { TravailScrape } from "@sfs/contracts";

const ETAPES: [string, string][] = [
  ["robots", "Vérification du robots.txt"],
  ["collecte", "Collecte des pages"],
  ["enrichissement", "Enrichissement de l'identité légale"],
  ["regles", "Extraction par règles"],
  ["lecture_llm", "Lecture par le modèle"],
  ["offres", "Score et classement des offres"],
  ["argumentaire", "Rédaction de l'argumentaire"],
  ["indexation", "Indexation vectorielle"]
];

export function SuiviEtapes({ travail, onOuvrir }: { travail: TravailScrape; onOuvrir: (id: string) => void }) {
  const courante = ETAPES.findIndex(([k]) => k === travail.etape);

  if (travail.statut === "echoue") {
    return (
      <div className="panel erreur-bloc">
        <h2 className="blocktitle">L'analyse n'a pas abouti</h2>
        <p>{travail.erreur ?? "Cause inconnue."}</p>
        <p className="mut petit">
          Les causes fréquentes : site entièrement dynamique, collecte interdite par robots.txt, ou domaine injoignable.
        </p>
      </div>
    );
  }

  return (
    <div className="panel">
      <h2 className="blocktitle">Analyse de {travail.url}</h2>
      <div className="progress"><i style={{ width: `${travail.progression}%` }} /></div>
      <p className="mut petit">
        {travail.progression}% — vous pouvez fermer cet écran, le travail continue côté serveur.
      </p>

      {ETAPES.map(([cle, libelle], i) => {
        // L'indexation vectorielle tourne sur une file séparée après coup :
        // le job principal se termine sans l'attendre, donc "terminé" ne
        // veut pas dire "indexé". On l'affiche à part, jamais comme bloquante.
        const planifieeEnArrierePlan = cle === "indexation" && travail.statut === "termine";
        const etat = planifieeEnArrierePlan
          ? "planifiee"
          : travail.statut === "termine" || i < courante ? "ok" : i === courante ? "run" : "wait";
        return (
          <div key={cle} className={`etape ${etat}`}>
            <span className="ic">
              {etat === "ok" ? "✓" : etat === "run" ? "⟳" : etat === "planifiee" ? "⏳" : "○"}
            </span>
            <span>
              {libelle}
              {planifieeEnArrierePlan ? " — planifiée, en cours en arrière-plan" : ""}
              {cle === "collecte" && travail.pagesCollectees > 0 ? ` — ${travail.pagesCollectees} pages` : ""}
              {cle === "offres" && travail.signauxDetectes > 0 ? ` — ${travail.signauxDetectes} constats` : ""}
            </span>
          </div>
        );
      })}

      {travail.statut === "termine" && travail.prospectId && (
        <button className="btn" style={{ marginTop: 14 }} onClick={() => onOuvrir(travail.prospectId!)}>
          Ouvrir la fiche
        </button>
      )}
    </div>
  );
}
